import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApproveFeeScheduleDialogComponent } from './approve-fee-schedule-dialog.component';
import { MaterialModule } from '../../../app/material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatInputModule, MaterialModule],
  declarations: [ApproveFeeScheduleDialogComponent],
  exports: [ApproveFeeScheduleDialogComponent]
})
export class ApproveFeeScheduleDialogModule {}
